module.exports = __webpack_public_path__ + "static/media/pantanal-thumbnail.fe92f53b.webp";